import React from 'react';


const Invites = () => {
    return (
        <div>
            Invites
        </div>
    )
}

export default Invites